import { createContext } from 'react';
import type { AlertColor } from '@mui/material';

export type Toast = { message: string; severity: AlertColor };

export interface ToastApi {
  /** Something worked. Brief, because nobody needs to dwell on it. */
  success: (message: string) => void;
  /** Something did not work, phrased for a person. Stays long enough to read twice. */
  failure: (message: string) => void;
  /**
   * Something did not work and all we have is the error.
   *
   * Routed through `apiErrorMessage()` so every caller gets the API's own sentence rather than inventing
   * its own — that helper exists because two hand-rolled copies were reading a shape the client
   * interceptor had already discarded, and every failure rendered "Something went wrong."
   */
  failed: (error: unknown, fallback?: string) => void;
}

/**
 * Split from the provider and the hook for the reason `features/auth` is: a file exporting both a component
 * and a non-component breaks fast refresh, and eslint says so.
 */
export const ToastContext = createContext<ToastApi | null>(null);
